export const canDropOptions = [
  {
    label: "是",
    value: true
  },
  {
    label: "否",
    value: false
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/MobileAppoint/options.js